import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";

function AthleteSearch({ handleSearch, reference }) {
  return (
    <div className="mb-4 flex items-center w-full border border-gray-300 rounded-md overflow-hidden">
      <input
        type="text"
        ref={reference}
        name="search"
        placeholder="Search Athletes..."
        className="px-4 py-2 basis-11/12 focus:outline-none"
        onChange={handleSearch}
      />
      <button
        type="button"
        className="basis-1/12 bg-white text-slate-500 flex items-center justify-center"
      >
        <FontAwesomeIcon icon={faSearch} size="lg" />
      </button>
    </div>
  );
}

export default AthleteSearch;
